import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvMatTooltipModule } from '../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListDisplayStudentModule } from '../lists/list-display/list-display-student/list-display-student.module';
import { ContentToolsModule } from './../../shell/content-tools/content-tools.module';
import { GraphListComponent } from './graph-list.component';
import { GraphListService } from './graph-list.service';

@NgModule({
  declarations: [GraphListComponent],
  imports: [NvMatTooltipModule, CommonModule, ContentToolsModule, ListDisplayStudentModule],
  providers: [GraphListService],
})
export class GraphListModule {}
